import { Body, Button } from "@growtherapy/sprout-ui";
import { twMerge } from "tailwind-merge";
import { useClientLogin as useBaseClientLogin } from "./useClientLogin";
import { CLIENT_LOGIN_BUTTON_LABEL, CLIENT_LOGIN_PROMPT } from "../lang";

export type LoginButtonProps = {
  className?: string;
  useClientLogin?: typeof useBaseClientLogin;
};

/** A tiny inline, link-style login button. */
export function LoginButton({
  className,
  useClientLogin = useBaseClientLogin,
}: LoginButtonProps) {
  const { isClientAuthEnabled, handleLogin } = useClientLogin();

  if (!isClientAuthEnabled) return null;

  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      <Body.Default emphasis>{CLIENT_LOGIN_PROMPT}</Body.Default>
      <Button
        className="rebrand:min-h-content rebrand:typography-body-emphasis-default"
        use="link"
        onClick={handleLogin}
      >
        {CLIENT_LOGIN_BUTTON_LABEL}
      </Button>
    </div>
  );
}
